<template>
  <el-config-provider namespace="ep" :locale="uz">
    <template v-if="!isLoading">
      <component :is="route.meta.layout ? route.meta.layout : EmptyLayout">
        <router-view />
      </component>
    </template>
    <the-proloader v-else></the-proloader>
  </el-config-provider>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAuthStore } from "~/stores/auth";
import EmptyLayout from "./components/layouts/EmptyLayout.vue";
import { storeToRefs } from "pinia";
// @ts-expect-error
import uz from "element-plus/dist/locale/uz-uz.mjs";

const { user } = storeToRefs(useAuthStore());
const { getUser, getUserForLanding } = useAuthStore();
const router = useRouter();
const route = useRoute();

// Umumiy loading holati
const isLoading = ref(true);
const isUserLoaded = ref(false);
const isResourcesLoaded = ref(false);

// Resurslar yuklangan holatini tekshirish
const checkAllLoaded = () => {
  if (isUserLoaded.value && isResourcesLoaded.value) {
    isLoading.value = false;
  }
};

// User ma'lumotlarini yuklash
const loadUserData = async () => {
  try {
    const hostname = window.location.hostname;
    const parts = hostname.split(".");

    if (parts.length > 2) {
      // Subdomain mavjud (app.smartkpi.uz kabi)
      await getUser();
      if (route.path === "/") {
        router.push("/dashboard");
      }
    } else {
      // Landing page
      await getUserForLanding();
    }
  } catch (error) {
    router.push("/auth/login");
  } finally {
    isUserLoaded.value = true;
    checkAllLoaded();
  }
};

// DOM va resurslar yuklanganligi holati
onMounted(async () => {
  // User ma'lumotlarini yuklash
  loadUserData();

  // Sahifa resurslarini yuklashni tekshirish
  if (document.readyState === "complete") {
    isResourcesLoaded.value = true;
    checkAllLoaded();
  } else {
    window.addEventListener("load", () => {
      isResourcesLoaded.value = true;
      checkAllLoaded();
    });
  }
});

// Ikkala holat o'zgarishini kuzatish
watch([isUserLoaded, isResourcesLoaded], () => {
  checkAllLoaded();
});
</script>

<style>
#app {
  color: var(--ep-text-color-primary);
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background-color: #406bff;
  border-radius: 4px;
}
</style>
